/* @flow */
import { Record } from 'immutable';

export const PENDING = 'PENDING';
export const ACTIVE = 'ACTIVE';

export type RawOptions = {
  type?: string,
  query?: string,
  sortBy?: string,
  sortOrder?: 'ASC' | 'DESC',
};

export const Options = Record({
  type: null,
  query: '',
  sortBy: 'name',
  sortOrder: 'DESC',
});

export const StandardMarketplace = Record({
  feedGuid: null,
  name: '',
  iconUrl: '',
  description: '',
  credentialsType: '',
  maximumAccess: null,
  state: null,
  enclaveGuid: null,
  companyGuid: null,
  externalUrl: null,
  label: null,
  createdBy: '',
  updatedBy: '',
  created: null,
  updated: null,
  lastPulled: null,
  subscriptionDate: null,
});



// WEBPACK FOOTER //
// ./src/app/modules/marketplace/types.js